import { MvnCodeInitiate } from "../../lib/const";
import { MvnCodeFE } from "../const";

export const DOCS_COMMON_LANG: {
  CREATE_NOUN: MvnCodeFE;
  BACK_TO_LIST_NOUN: MvnCodeFE;
  DOWNLOAD_NOUN: MvnCodeFE;
  EXIT_NOUN: MvnCodeFE;
  NAME_NOUN: MvnCodeFE;
  NAME_PLACEHOLDER: MvnCodeFE;
  VERSION_PLACEHOLDER: MvnCodeFE;
  EMAIL_NOUN: MvnCodeFE;
  PHONE_NOUN: MvnCodeFE;
  TITLE_NOUN: MvnCodeFE;
  GROUP_NOUN: MvnCodeFE;
  STATUS_NOUN: MvnCodeFE;
  ENTER_VALUE_PLACEHOLDER: MvnCodeFE;
  FILTER_NOUN: MvnCodeFE;
  CLEAR_FILTERS_NOUN: MvnCodeFE;
  FILE_NOUN: MvnCodeFE;
  TABLE_ROW_SELECT_DESCRIPTION: MvnCodeFE;
  EDIT_NOUN: MvnCodeFE;
  STRING_EXCEED_MAX_LENGTH: MvnCodeFE;
  NUMBER_EXCEED_MAX_LENGTH: MvnCodeFE;
  STRING_EXCEED_MIN_LENGTH: MvnCodeFE;
  NUMBER_EXCEED_MIN_LENGTH: MvnCodeFE;
  INVALID_CHARS: MvnCodeFE;
  INVALID_EMAIL: MvnCodeFE;
  INVALID_PHONE: MvnCodeFE;
  INVALID_TEL: MvnCodeFE;
  EMPTY_FILE_WARN: MvnCodeFE;
  REQUIRED_FIELD: MvnCodeFE;
  NOT_FOUND_PAGE_TITLE: MvnCodeFE;
  NOT_FOUND_PAGE_DESC: MvnCodeFE;
  NOT_AUTHORIZED_PAGE_TITLE: MvnCodeFE;
  NOT_AUTHORIZED_PAGE_DESC: MvnCodeFE;
  GOTO_HOME_NOUN: MvnCodeFE;
  UPLOAD_PROCESSING: MvnCodeFE;
  UPLOAD_COMPLETED: MvnCodeFE;
  UPLOAD_FAILED: MvnCodeFE;
  COMPLAIN_TO_ADMIN: MvnCodeFE;
  INVALID_DOCUMENT_FORMAT: MvnCodeFE;
  DOCS_UPDATE_NOTIFICATION_HEADER_DESCRIPTION: MvnCodeFE;
  REFRESH_NOUN: MvnCodeFE;
} = {
  CREATE_NOUN: {
    ko: "생성",
    en: "Create",
  },
  BACK_TO_LIST_NOUN: {
    ko: "뒤로 가기",
    en: "Back to List",
  },
  DOWNLOAD_NOUN: {
    ko: "다운로드",
    en: "Download",
  },
  EXIT_NOUN: {
    ko: "나가기",
    en: "Exit",
  },
  NAME_NOUN: {
    ko: "이름",
    en: "Name",
  },
  NAME_PLACEHOLDER: {
    ko: "이름 입력",
    en: "Enter name",
  },
  VERSION_PLACEHOLDER: {
    ko: "버전 입력",
    en: "Enter version",
  },
  EMAIL_NOUN: {
    ko: "이메일",
    en: "Email",
  },
  TITLE_NOUN: {
    ko: "제목",
    en: "Title",
  },
  PHONE_NOUN: {
    ko: "휴대폰",
    en: "Phone",
  },
  GROUP_NOUN: {
    ko: "그룹",
    en: "Group",
  },
  STATUS_NOUN: {
    ko: "상태",
    en: "Status",
  },
  ENTER_VALUE_PLACEHOLDER: {
    ko: "검색어 입력",
    en: "Enter value",
  },
  FILTER_NOUN: {
    ko: "필터",
    en: "Filter",
  },
  CLEAR_FILTERS_NOUN: {
    ko: "필터 초기화",
    en: "Clear",
  },
  FILE_NOUN: {
    ko: "파일",
    en: "File",
  },
  TABLE_ROW_SELECT_DESCRIPTION: {
    ko: "{count}개 선택됨",
    en: "{count} selected",
  },
  EDIT_NOUN: {
    ko: "수정",
    en: "Edit",
  },
  INVALID_CHARS: {
    ko: "영문, 숫자, 특수문자만 입력 가능합니다",
    en: "Only English, numbers, and special characters can be entered.",
  },
  INVALID_EMAIL: {
    ko: "이메일 형식을 확인해주세요.",
    en: "Please check the email format.",
  },
  INVALID_PHONE: {
    ko: "휴대폰번호가 올바르게 입력되었는지 확인해주세요.",
    en: "Please check the phone number format.",
  },
  INVALID_TEL: {
    ko: "전화번호가 올바르게 입력되었는지 확인해주세요.",
    en: "Please check the phone number format.",
  },
  NUMBER_EXCEED_MAX_LENGTH: {
    ko: "{maxLength}이하로 입력해주세요.",
    en: "Please enter {maxLength} or less.",
  },
  STRING_EXCEED_MAX_LENGTH: {
    ko: "{maxLength}자까지 입력 가능합니다.",
    en: "The input exceeds the maximum length of {maxLength} characters.",
  },
  STRING_EXCEED_MIN_LENGTH: {
    ko: "{minLength}자 이상 입력해주세요.",
    en: "Please enter {minLength} or more characters.",
  },
  NUMBER_EXCEED_MIN_LENGTH: {
    ko: "{minLength} 이상 입력해주세요.",
    en: "Please enter {minLength} or more.",
  },
  EMPTY_FILE_WARN: {
    ko: "파일 업로드가 필요합니다.",
    en: "File is empty.",
  },
  REQUIRED_FIELD: {
    ko: "필수 입력 항목입니다.",
    en: "Please fill in the required field.",
  },
  NOT_FOUND_PAGE_TITLE: {
    ko: "페이지를 찾을 수 없습니다.",
    en: "Page not found",
  },
  NOT_FOUND_PAGE_DESC: {
    ko: "홈으로 이동 후 다시 시도해주세요.",
    en: "Please go to home and try again.",
  },
  NOT_AUTHORIZED_PAGE_TITLE: {
    ko: "홈으로 이동 후 다시 시도해주세요.",
    en: "Please go to home and try again.",
  },
  NOT_AUTHORIZED_PAGE_DESC: {
    ko: "이 페이지에 접근할 수 있는 권한이 없습니다. 관리자에게 문의해주세요.",
    en: "You don’t have permission to access this page. Please contact your administrator.",
  },
  GOTO_HOME_NOUN: {
    ko: "홈으로 이동",
    en: "Go to home",
  },
  UPLOAD_PROCESSING: {
    ko: "업로드 중",
    en: "uploads processing",
  },
  UPLOAD_COMPLETED: {
    ko: "업로드 완료",
    en: "Uploads completed",
  },
  UPLOAD_FAILED: {
    ko: "업로드 실패",
    en: "Uploads failed",
  },
  COMPLAIN_TO_ADMIN: {
    ko: "관리자에게 문의해 주세요.",
    en: "Please contact system administrator.",
  },
  INVALID_DOCUMENT_FORMAT: {
    ko: "문서 형식이 올바르지 않습니다.",
    en: "Invalid document format",
  },
  DOCS_UPDATE_NOTIFICATION_HEADER_DESCRIPTION: {
    ko: "새 버전이 배포되었습니다. 모든 기능이 정상 작동할 수 있도록 새로고침이 필요합니다.",
    en: "A new version is available. Please refresh the page to ensure all features work properly.",
  },
  REFRESH_NOUN: {
    ko: "새로고침",
    en: "Refresh",
  },
};

MvnCodeInitiate(DOCS_COMMON_LANG);
